import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestsState, Request } from "../../types";

const initialState: RequestsState = {
  sentRequests: {},
  receivedRequests: {},
};

const requestsSlice = createSlice({
  name: "requests",
  initialState,
  reducers: {
    setSentRequests: (
      state,
      action: PayloadAction<Record<string, Request>>,
    ) => {
      state.sentRequests = action.payload;
    },
    setReceivedRequests: (
      state,
      action: PayloadAction<Record<string, Request>>,
    ) => {
      state.receivedRequests = action.payload;
    },
  },
});

export const { setSentRequests, setReceivedRequests } = requestsSlice.actions;
export default requestsSlice.reducer;
